import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { SharedDataService } from '../../../../services/shared-data.service';

dayjs.extend(utc);
dayjs.extend(timezone);
@Pipe({
  name: 'formatDate',
  standalone: true,
})
export class FormatDatePipe implements PipeTransform {
  constructor(private sharedDataService: SharedDataService) {}

  transform(dateString: string): string {
    const selectedTimezone = this.sharedDataService.selectedTimezoneValue || 'EST';

    // Convert timezone abbreviation to IANA timezone name for dayjs
    const ianaTimezone = this.getIanaTimezone(selectedTimezone);
    const date = dayjs(dateString).tz(ianaTimezone);

    const day = date.format('DD');
    const month = date.format('MMM');
    const year = date.format('YYYY');

    const formattedTime = date.format('hh:mm:ss A');
    const timezoneAbbr = this.getTimeZoneAbbr(selectedTimezone);

    return `${day} ${month} ${year} ${formattedTime} ${timezoneAbbr}`;
  }

  private getTimeZoneAbbr(timeZone: string): string {
    // Map of timezone abbreviations to their display abbreviations
    const timeZoneMap: { [key: string]: string } = {
      'Asia/Kolkata': 'IST',
      'Asia/Calcutta': 'IST',
      'America/Los_Angeles': 'PST',
      'America/New_York': 'EST',
      'Europe/London': 'GMT',
      'Asia/Dubai': 'GST',
      'Asia/Singapore': 'SGT',
      'Australia/Sydney': 'AEST',
      'Pacific/Auckland': 'NZST',
      'Europe/Paris': 'CET',
      'Asia/Tokyo': 'JST',
      'EST': 'EST',
      'PST': 'PST',
      'IST': 'IST',
      'GMT': 'GMT',
      'CST': 'CST',
      'MST': 'MST',
      'BST': 'BST',
      'CET': 'CET',
      'EET': 'EET',
      'JST': 'JST',
      'AEST': 'AEST',
      'GST': 'GST',
      'SGT': 'SGT',
      'NZST': 'NZST',
      'UTC': 'UTC'
    };

    // If we have a mapping, use it
    if (timeZoneMap[timeZone]) {
      return timeZoneMap[timeZone];
    }

    // If it's already a short abbreviation (3-4 characters), return it as is
    if (timeZone.length <= 4 && /^[A-Z]+$/.test(timeZone)) {
      return timeZone;
    }

    // For any other timezone, return the input as is
    return timeZone;
  }

  private getIanaTimezone(timezone: string): string {
    // Map timezone abbreviations to IANA timezone names
    const timezoneMap: { [key: string]: string } = {
      'EST': 'America/New_York',
      'PST': 'America/Los_Angeles',
      'IST': 'Asia/Kolkata',
      'GMT': 'Europe/London',
      'CST': 'America/Chicago',
      'MST': 'America/Denver',
      'BST': 'Europe/London',
      'CET': 'Europe/Paris',
      'EET': 'Europe/Bucharest',
      'JST': 'Asia/Tokyo',
      'AEST': 'Australia/Sydney',
      'GST': 'Asia/Dubai',
      'SGT': 'Asia/Singapore',
      'NZST': 'Pacific/Auckland',
      'UTC': 'UTC'
    };

    return timezoneMap[timezone] || timezone;
  }
}
